export default "/images/phone.svg?5376c5539e76f769cf4501551fb2a796";